import { API_DOMAIN } from "../../constants/api";
import axios from "../fetch/fetch";

export type TrainingClassification = "CRITICAL" | "NON_CRITICAL";

const UPDATE_TRAINING_CLASSIFICATION_API = `${API_DOMAIN}/documents/update-training-classification`;

export async function updateTrainingClassificationAPI(
    updates: { confluenceDocumentId: string; version: string; trainingClassification: TrainingClassification }[]
): Promise<any> {
    const response = await axios.put(UPDATE_TRAINING_CLASSIFICATION_API, { updates });
    return response.data;
}

